<template>
  <div>
    <ItemTujuan v-for="(item, index) in formTujuan" :key="index" 
      :formKey="index"
      :formLength="formTujuan.length"
      :defaultValue="formTujuan[index]"
      @input="setFormValue(index, $event)"
      @addNewForm="addNewForm()"
      @deleteForm="deleteForm(index)"
    >
    </ItemTujuan>
  </div>
</template>

<script>
import ItemTujuan from "./ItemTujuan";

export default {
  components: {
    ItemTujuan
  },
  props: {
    defaultData : {
      type : Array,
      required : false
    },
    inputType : {
      type: String,
      required : true
    }
  },
  data(){
    return {
      formTujuan : [
        {nama : '', email : ''}
      ],
    }
  },
  watch : {
    formTujuan: {
      handler() { 
        this.$emit("input", this.formTujuan);
      },
      deep: true
    }
  },
  mounted(){
    this.setDefaultData();
  },
  methods: {
    setDefaultData(){
      var self = this;
      if(self.inputType == 'update' && self.defaultData.length != 0){
        self.formTujuan.splice(0,1);
        self.defaultData.map(item => {
          self.formTujuan.push({id: item.id, nama: item.nama, email: item.email})
        });
      }
    },
    setFormValue(index, event){
      this.formTujuan[index].nama = event.nama;
      this.formTujuan[index].email = event.email;
    },
    addNewForm(){
      this.formTujuan.push({nama : '', email : ''});
    },
    deleteForm(index){
      let tujuanId = '-'; 
      if(this.inputType == 'update'){
        tujuanId = this.formTujuan[index].id;
        this.$emit('delete', tujuanId);
      }
      this.formTujuan.splice(index,1);
    }
  }
};
</script>

<style>
.flatpickr-calendar.open {
  z-index: 100002;
}
</style>
